let readMore = {
    init: () => {
        const readMoreButtons = document.querySelectorAll('[data-read-more-button]');
        readMoreButtons.forEach(readMoreButton => {
            var readMoreContainer = readMoreButton.closest('[data-read-more]');
            if(readMoreContainer)
            {
                readMoreButton.addEventListener('click', 
                function() { 
                    readMore.unhideContainer(readMoreContainer) 
                    readMore.hideButton(readMoreButton);
                })

            } else {
                // if we cannot find parrent, we hide the button at startup
                readMore.hideButton(readMoreButton);
            }
        });
    },
    unhideContainer: (readMoreContainer) => {
        readMoreContainer.removeAttribute("data-read-more");
    },
    hideButton: (readMoreButton) => {
        readMoreButton.hidden = true;
    }
}
export default readMore;